import { useMutation, gql } from "@apollo/client";
import useGravityForm from "../../hooks/use-gravity-form";
import { createRef } from "react";

// Components
import GravityFormsField from "./gravity-form-fields";

// import { NextRequest, NextResponse } from "next/server";
// export async function POST(req) {
//   console.log(req);
//   const data = await req.json();
//   console.log(data);
//   //   return;
//   return new Response("Hello, Next.js!");
// }
// export async function POST(req, res) {
//   try {
//     console.log(req);
//     const data = req.formData();
//     console.log(data);
//     const body = await req.json();
//     console.log(body);
//     return NextResponse.json({ message: "Hello, world!" });
//   } catch (err) {
//     console.error(err);
//     return NextResponse.error();
//   }
// }

export default function Gform({ form }) {
  if (!form) {
    return;
  }

  const submitRef = createRef();

  // Variables
  const [submitForm, { data, loading, error }] = useMutation(SUBMIT_FORM);
  const haveEntryId = data?.submitGfForm?.entry?.id;
  const haveFieldErrors = data?.submitGfForm?.errors?.length;
  const wasSuccessfullySubmitted = haveEntryId && !haveFieldErrors;
  const defaultConfirmation = form.confirmations?.find(
    (confirmation) => confirmation?.isDefault
  );
  const formFields = form.formFields?.nodes || [];
  const databaseId = form.databaseId;
  const { state } = useGravityForm();

  function handleSubmit(event) {
    event.preventDefault();
    if (loading) return;
    submitForm({
      variables: {
        databaseId: databaseId,
        fieldValues: state,
      },
    }).catch((error) => {
      console.error(error);
    });
  }

  function getFieldErrors(id) {
    if (!haveFieldErrors) return [];
    return data.submitGfForm.errors.filter((error) => error.id === id);
  }

  if (wasSuccessfullySubmitted) {
    return (
      <p className="confirmation">
        {defaultConfirmation?.message ||
          "Form successfully submitted - thank you."}
      </p>
    );
  }

  return (
    <form method="post" onSubmit={handleSubmit}>
      {formFields.map((field, i) => (
        <GravityFormsField
          key={field.databaseId}
          field={field}
          fieldErrors={getFieldErrors(field?.databaseId)}
          ref={submitRef}
        />
      ))}
      {error ? <p className="error-message">{error.message}</p> : null}
      <button type="submit" disabled={loading} ref={submitRef}>
        {form?.button?.text || "Submit"}
      </button>
    </form>
  );
}

const SUBMIT_FORM = gql`
  mutation submitForm($databaseId: ID!, $fieldValues: [FormFieldValuesInput]!) {
    submitGfForm(
      input: {
        id: $databaseId
        fieldValues: $fieldValues
        saveAsDraft: false # If true, the submission will be saved as a draft entry.
        # Set the following to validate part of a multipage form without saving the submission.
        # sourcePage: 1
        # targetPage: 0
      }
    ) {
      confirmation {
        type
        message # The message HTML - if the confirmation type is a "MESSAGE".
        url # The redirect URL - if the confirmation type is a "REDIRECT".
      }
      entry {
        id
        ... on GfSubmittedEntry {
          databaseId
        }
        ... on GfDraftEntry {
          resumeToken
        }
      }
      errors {
        id # The field ID that failed validation.
        message
        connectedFormField {
          # The full FormField object if you need more info.
          databaseId
          type
        }
      }
    }
  }
`;
